import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/Dynamic_Price_Icon.svg"

const DynamicPriceIcon: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 30 30'} component={Icon} {...props} fill="currentColor" />
export default DynamicPriceIcon
